import {BUSCAR_CLIENTES_EMPRESA} from '../../actions/types'

const initialState = undefined;

export default function reducerBuscarClientesEmpresa(state = [], action = initialState) {
    switch (action.type) {
        case BUSCAR_CLIENTES_EMPRESA: {
            const listaClientes = action.payload.data;

            if (listaClientes) {
                return listaClientes
            }
            return []
        }

        default: {
            return state
        }
    }
}